export default async function getLessons() {
    const lessonsRef = this.db.collection('lessons');
    const res = await lessonsRef.get();
    const lessons = res.docs.map((lesson) => lesson.data());
    return lessons;
}
